/* global axios */
import ApiClient from './ApiClient';

class UserPhoneCredentials extends ApiClient {
  constructor() {
    super('phone_credentials', { accountScoped: true });
  }

  update(params) {
    return axios.patch(`${this.url}`, params);
  }

  getTurnCredentials() {
    return axios.get(`${this.url}/turn_credentials`);
  }

  getPhoneStatus(agentId) {
    return axios.get(`${this.baseUrl()}/agents/${agentId}/phone_status`);
  }

  notReady(agentId) {
    return axios.post(
      `${this.baseUrl()}/agents/${agentId}/phone_status/not_ready`
    );
  }

  ready(agentId) {
    return axios.post(`${this.baseUrl()}/agents/${agentId}/phone_status/ready`);
  }

  notReadyInQueue(agentId, queueNumber) {
    return axios.post(
      `${this.baseUrl()}/agents/${agentId}/phone_status/queues/${queueNumber}/not_ready`
    );
  }

  readyInQueue(agentId, queueNumber) {
    return axios.post(
      `${this.baseUrl()}/agents/${agentId}/phone_status/queues/${queueNumber}/ready`
    );
  }

  setQueueStatus(agentId, status) {
    return axios.post(
      `${this.baseUrl()}/agents/${agentId}/phone_status/queue_status`,
      { status }
    );
  }

  setQueueStatusInQueue(agentId, queueNumber, status) {
    return axios.post(
      `${this.baseUrl()}/agents/${agentId}/phone_status/queues/${queueNumber}/queue_status`,
      { status }
    );
  }
}

export default new UserPhoneCredentials();
